module.exports = "/packs/media/images/icons/Save-d94a23aa59e54356360f175c0b42c6fb.svg";